import React, { Component } from 'react';

const $= window.$;


class IseekSavedform extends Component {
	constructor(props) {
		super(props);
		this.state={
			pollid:'',
			senteditf:'',
		}
		this.getPollId = this.getPollId.bind(this);
		this.buttonClick = this.buttonClick.bind(this);
	}


	getPollId(e){
		 this.setState({pollid: e.target.value});
		 
	}

	buttonClick(){
		// alert(this.state.pollid);
		var polldata = this.state.pollid;
		this.props.sendData(polldata);

	}

	// componentWillReceiveProps(nextProps) {

 //         if(nextProps.sentedits!=undefined){

 //         	//alert(nextProps.sentedits);

 //         	if(nextProps.sentedits == 'selected'){
	// 	       	$("#cmbPollQuestion option:last").attr("selected", "selected");
	// 	       	$("#btnsubpoll").click();
 //           	}
 //         }
 //    }



		render() {


        	const {savedForms} = this.props;

        	// const {sentedits} = this.props;

        	// alert(sentedits);
 			
        	//alert(JSON.stringify(savedForms));
        	let rows = null;
        	if(savedForms != undefined || savedForms != null){
				 rows = savedForms.map((savedform,i) => {
	                return (
			                   <option key={i} value={savedform.snap_poll_id_pk+'_'+savedform.snap_poll_title}>{savedform.snap_poll_title}</option>
			                )
			       });
        	}

		       

			
			
			return (
				<div>
					<div className="fdbk-content existing-form">
					    <select name="cmbPollQuestion" id="cmbPollQuestion"  className="cmbbox_form" onChange={(e)=>this.getPollId(e)}>
					    	<option value=''>Select</option>
					    	{rows}
					    </select>
					  
					    <div className="fdbk-btn">
					    	<input type="hidden" value={this.state.pollid}/>
					        <input type="button" name="btnSubmit" id="btnsubpoll" value="Select" className="button-accept" title="Select" alt="Select" onClick={this.buttonClick}/>
					     </div>
					</div>
		        </div> 

			);
		}
}

export default IseekSavedform;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekSavedform.js